import { z } from 'zod';
import { STATUS_VOUCHER } from './campanha.js';

/**
 * Schemas de consulta e entrega de voucher (SPEC §8 / §5.3). O voucher é ao
 * portador: a entrega pode registrar um retirante diferente do dono.
 */

export const listarVouchersQuerySchema = z.object({
  clienteId: z.string().uuid().optional(),
  status: z.enum(STATUS_VOUCHER).optional(),
  codigo: z.string().trim().min(1).optional(),
});
export type ListarVouchersQuery = z.infer<typeof listarVouchersQuerySchema>;

export const entregarVoucherSchema = z.object({
  /** quem retirou — texto livre; pode não ser o dono do voucher (SPEC §5.3) */
  retiradoPor: z.string().trim().min(1, 'Informe quem retirou o brinde'),
});
export type EntregarVoucherInput = z.infer<typeof entregarVoucherSchema>;

/**
 * Voucher (linha de `concessao` de `movimento_brinde`) como o painel consome
 * (UX-PAINEL-INTERNO §3 e §7). `status` é derivado (`disponivel`/`entregue`),
 * `retiradoPor` é o texto livre da entrega. Mantém `entreguePara` como alias
 * legado (contrato das tools do Hermes).
 */
export const voucherPainelSchema = z.object({
  id: z.string().uuid(),
  voucherCodigo: z.string(),
  clienteId: z.string().uuid(),
  clienteNome: z.string(),
  indicacaoId: z.string().uuid(),
  papel: z.enum(['indicador', 'indicado']).nullable(),
  nivel: z.number().int().nullable(),
  descricao: z.string(),
  status: z.enum(STATUS_VOUCHER),
  /** ISO 8601 */
  concedidoEm: z.string(),
  /** ISO 8601 — `null` enquanto disponível */
  entregueEm: z.string().nullable(),
  retiradoPor: z.string().nullable(),
  /** @deprecated use `retiradoPor` */
  entreguePara: z.string().nullable(),
});
export type VoucherPainel = z.infer<typeof voucherPainelSchema>;

/** `detalhes` do 409 `voucher_ja_entregue` (E10) — a UI mostra "já retirado". */
export const voucherConflitoDetalhesSchema = z.object({
  entregueEm: z.string().nullable(),
  retiradoPor: z.string().nullable(),
});
export type VoucherConflitoDetalhes = z.infer<typeof voucherConflitoDetalhesSchema>;
